import * as React from 'react'
import { convertYYYYMMDD } from '@/utils/convert/yyyymmdd'
import * as style from './index.module.css'

interface Props {
  /** 作成日 */
  readonly createdAt: string
}

/**
 * @file 作成日の共通components
 *
 * @param {string} createdAt - 作成日
 */
export const CreatedAt = ({ createdAt }: Props): React.JSX.Element => (
  <div className={style.root}>{convertYYYYMMDD(createdAt)}</div>
)
